/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsActivateSupport
 */
export interface MelcoModelsActivateSupport {
    /**
     * 
     * @type {number}
     * @memberof MelcoModelsActivateSupport
     */
    minutes?: number;
}

export function MelcoModelsActivateSupportFromJSON(json: any): MelcoModelsActivateSupport {
    return MelcoModelsActivateSupportFromJSONTyped(json, false);
}

export function MelcoModelsActivateSupportFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsActivateSupport {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'minutes': !exists(json, 'minutes') ? undefined : json['minutes'],
    };
}

export function MelcoModelsActivateSupportToJSON(value?: MelcoModelsActivateSupport | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'minutes': value.minutes,
    };
}


